module.exports = __webpack_public_path__ + "test.688ee75a6038428f703b.png";


//////////////////
// WEBPACK FOOTER
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/assets/test.png
// module id = ../../../../../src/assets/test.png
// module chunks = main